import type { ExternalConfigType } from "../../../../shared-logic/types/ExternalPriceType";
import type { BuildAndBuyActionsType } from "../store";
import type { SavedConfigType } from "../../../../shared-logic/types/SaveTypes";

export const CONFIGURATION_START_SAVE = "save/startConfigSave" as const;
export const CONFIGURATION_FINISH_SAVE = "save/finishConfigSave" as const;
export const CONFIGURATION_ERROR_SAVE = "save/errorConfigSave" as const;
export const CONFIGURATION_INVALIDATE_SAVE = "save/invalidateConfigSave" as const;

export type StartConfigSaveType = {
    type: typeof CONFIGURATION_START_SAVE;
    postSaveAction?: BuildAndBuyActionsType;
    config?: ExternalConfigType;
};

export type FinishConfigSaveType = {
    type: typeof CONFIGURATION_FINISH_SAVE;
    // qrCode is added by logic parsing.
    qrCode?: string;
    data: SavedConfigType;
};
export type ErrorConfigSaveType = { type: typeof CONFIGURATION_ERROR_SAVE };
export type InvalidateConfigSaveType = { type: typeof CONFIGURATION_INVALIDATE_SAVE };

export const startConfigSave = (postSaveAction?: BuildAndBuyActionsType): StartConfigSaveType => ({
    type: CONFIGURATION_START_SAVE,
    postSaveAction,
});
export const finishConfigSave = (data: SavedConfigType): FinishConfigSaveType => ({
    type: CONFIGURATION_FINISH_SAVE,
    data,
});
export const errorConfigSave = (): ErrorConfigSaveType => ({ type: CONFIGURATION_ERROR_SAVE });
export const invalidateConfigSave = (): InvalidateConfigSaveType => ({ type: CONFIGURATION_INVALIDATE_SAVE });

export type SaveActionsType =
    | StartConfigSaveType
    | FinishConfigSaveType
    | ErrorConfigSaveType
    | InvalidateConfigSaveType;
